import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import {
  getCurrentQuestionInfo,
  getQuizDetails,
  getQuizSectionalQuestions
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import useOngoingSection from '@cont/Quiz/Taking/Common/useOngoingSection';
import { NTA_COLORS, NTA_SIDEBAR_WIDTH } from '../constants';
import { ntaPageCss } from '../typography';
import NtaPaletteLegend from './NtaPaletteLegend';
import NtaPaletteQuestion from './NtaPaletteQuestion';

const Sidebar = styled.aside`
  width: ${NTA_SIDEBAR_WIDTH};
  flex-shrink: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
  overflow: hidden;
  border-radius: 12px;
  ${ntaPageCss}
`;

const LegendCard = styled.div`
  background: ${NTA_COLORS.white};
  border-radius: 8px;
  padding: 16px 16px 24px;
  flex-shrink: 0;
`;

const PaletteCard = styled.div`
  background: ${NTA_COLORS.white};
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

const PaletteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 38px);
  gap: 2px;
  justify-content: center;
`;

const NtaNavigation = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const { sectionUID } = useSelectorWithShallowEqual(getCurrentQuestionInfo);
  const sections = quizDetails?.sections ?? [];

  const activeSection =
    sections.find((section) => section.uid === sectionUID) ?? sections[0];

  const { allIds, byId } = useSelectorWithShallowEqual(
    getQuizSectionalQuestions(quizUID, activeSection?.uid)
  );
  const { isLocked } = useOngoingSection(activeSection?.uid);

  return (
    <Sidebar>
      <LegendCard>
        <NtaPaletteLegend sectionUID={activeSection?.uid} />
      </LegendCard>
      {activeSection?.uid && !isLocked ? (
        <PaletteCard>
          <PaletteGrid>
            {allIds.map((id) => (
              <NtaPaletteQuestion
                key={id}
                sectionUID={activeSection.uid}
                questionUID={id}
                isLocked={isLocked}
                rank={byId[id].question_rank}
              />
            ))}
          </PaletteGrid>
        </PaletteCard>
      ) : null}
    </Sidebar>
  );
};

export default NtaNavigation;
